import { render } from "./CustomersTable.vue?vue&type=template&id=e713c754&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"

import "./CustomersTable.vue?vue&type=style&index=0&id=e713c754&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e713c754"]])

export default __exports__